import { render, staticRenderFns } from "./UploadYoutubeRecordedLectureModal.vue?vue&type=template&id=62f771d0&"
import script from "./UploadYoutubeRecordedLectureModal.vue?vue&type=script&lang=js&"
export * from "./UploadYoutubeRecordedLectureModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadYoutubeRecordedLectureModal.vue?vue&type=style&index=0&id=62f771d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports